//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import Button from "@material-ui/core/Button";
import * as Config from "eai-configurator-ui/components/configuration/utils/ConfigurationRegistry";
import * as Utils from "eai-configurator-ui/components/Utils";
import CircularProgress from "@material-ui/core/CircularProgress";
import ErrorMessageDialog, {useErrorMessageDialog,} from "eai-configurator-ui/components/configuration/dialog/ErrorMessageDialog";

const UploadFileWithConfigurationButton = ({
                                             url,
                                             icon,
                                             label,
                                             handleSuccess,
                                             selectedFiles,
                                             submitEmptyRequest,
                                             ...props
                                           }) => {
  const [submitted, setSubmitted] = React.useState(false);
  const [errorMessage, setErrorMessage] = useErrorMessageDialog();

  const handleSubmit = async () => {
    const configurationValues = Config.buildConfigurationValueDtos();

    // upload and submit files
    if (selectedFiles.length === 0 && submitEmptyRequest) {
      const data = new FormData();
      data.append("values", JSON.stringify({values: configurationValues}));
      await submitData(data);
    } else if (selectedFiles.length > 0) {
      selectedFiles.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
      for (let i = 0; i < selectedFiles.length; i++) {
        await upload(selectedFiles[i], configurationValues);
      }
    }
  };

  const upload = async (file, configurationValues) => {
    if (!submitted) {
      console.log("Submitting file [" + file + "] to URL [" + url + "]");
      setSubmitted(true);
      const data = new FormData();
      data.append("file", file);
      data.append("values", JSON.stringify({values: configurationValues}));
      await submitData(data);
    }
  };

  const submitData = async (data) => {
    await Utils.fetchData(
      url,
      {
        method: "POST",
        body: data,
      },
      false
    )
      .then((success) => {
        setSubmitted(false);
        if (handleSuccess) {
          handleSuccess();
        }
      })
      .catch((response) => {
        Utils.getErrorMessage(response, "Request failed.").then(
          setErrorMessage
        );
      });
  }

  return (
    <span>
      <ErrorMessageDialog {...errorMessage} />
      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        disabled={submitted}
        startIcon={
          submitted ? <CircularProgress color="inherit" size={20}/> : icon
        }
        {...props}
      >
        {label}
      </Button>
    </span>
  );
};
export default UploadFileWithConfigurationButton;
